import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
// import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { PlaneDepartureIconComponent } from '../icons/plane-departure-icon/plane-departure-icon.component';
import { AccordionModule } from 'primeng/accordion';
import { PasswordModule } from 'primeng/password';
import { SkeletonModule } from 'primeng/skeleton';
import { TableSkeletonLoadingComponent } from './table-skelaton-loading/table-skeleton-loading.component';
import { ChipModule } from 'primeng/chip';
import { PlaneIconComponent } from '../icons/plane-icon/plane-icon.component';
import { ApiService } from 'src/app/services/generic/api.service';
import { ChartModule } from 'primeng/chart';
import { RippleModule } from 'primeng/ripple';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { AvatarModule } from 'primeng/avatar';
import { ProgressBarModule } from 'primeng/progressbar';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { FileUploadModule } from 'primeng/fileupload';
import { EditorModule } from 'primeng/editor';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { MultiSelectModule } from 'primeng/multiselect';
import { AudioPlayerComponent } from 'src/app/media/audio-player/audio-player.component';
import { UrlSanitizePipe } from 'src/app/pipes/url-sanitize.pipe';
import { CheckPlayIconComponent } from '../icons/check-play-icon/check-play-icon.component';
import { CheckDownloadIconComponent } from '../icons/check-download-icon/check-download-icon.component';

import { SelectModule } from 'primeng/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DrawerModule } from 'primeng/drawer';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DatePickerModule } from 'primeng/datepicker';
import { PrimeNGIcons } from './primeng-icons';



@NgModule({
  declarations: [
    PlaneDepartureIconComponent,
    TableSkeletonLoadingComponent,
    PlaneIconComponent,
    AudioPlayerComponent,
    CheckPlayIconComponent,
    CheckDownloadIconComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TableModule,
    //  DropdownModule,
    SelectModule,
    ButtonModule,
    // InputSwitchModule,
    DialogModule,
    ToastModule,
    DynamicDialogModule,
    InputNumberModule,
    InputTextModule,
    TooltipModule,
    // SidebarModule,
    AccordionModule,
    PasswordModule,
    SkeletonModule,
    CommonModule,
    ChipModule,
    AvatarModule,
    FileUploadModule,
    EditorModule,
    BadgeModule,
    OverlayPanelModule,
    InputGroupModule,
    InputGroupAddonModule,
    TimelineModule,
    CardModule,
    SplitButtonModule,
    CalendarModule,
    DividerModule,
    RippleModule,
    TagModule,
    ChartModule,
    AvatarGroupModule,
    ProgressBarModule,
    PanelModule,
    TabViewModule,
    MultiSelectModule,
    ToggleSwitchModule,
    DrawerModule,
    InputIconModule,
    IconFieldModule,
    DatePickerModule,

    PrimeNGIcons
  ],

  exports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TableModule,
    SelectModule,
    // DropdownModule,
    ButtonModule,
    // InputSwitchModule,
    DialogModule,
    TooltipModule,
    ToastModule,
    DynamicDialogModule,
    InputNumberModule,
    InputTextModule,
    // SidebarModule,
    AccordionModule,
    PasswordModule,
    SkeletonModule,
    ChipModule,
    AvatarModule,
    RippleModule,
    TagModule,
    ChartModule,
    AvatarGroupModule,
    ProgressBarModule,
    PanelModule,
    TabViewModule,
    FileUploadModule,
    EditorModule,
    BadgeModule,
    TimelineModule,
    OverlayPanelModule,
    InputGroupModule,
    DividerModule,

    InputGroupAddonModule,
    CardModule,
    SplitButtonModule,
    CalendarModule,

    PlaneDepartureIconComponent,
    TableSkeletonLoadingComponent,
    PlaneIconComponent,
    AudioPlayerComponent,
    CheckPlayIconComponent,
    CheckDownloadIconComponent,
    MultiSelectModule,
    ToggleSwitchModule,
    DrawerModule,
    InputIconModule,
    IconFieldModule,
    DatePickerModule,
    PrimeNGIcons

  ],
  providers: [ApiService, UrlSanitizePipe],
})
export class SharedModule { }